import Swiper from 'swiper/bundle';

export default class Slider {
    constructor(root, options = {}) {
        this.root = root;
        this.container = this.root.querySelector('.swiper-container');
        this.wrapper = this.root.querySelector('.swiper-wrapper');
        this.slides = this.root.querySelectorAll('.swiper-slide');
        this.next_btn = this.root.querySelector('.js-button-next');
        this.prev_btn = this.root.querySelector('.js-button-prev');

        if(!this.next_btn && !this.prev_btn) {
            this.next_btn = this.root.parentElement.querySelector('.js-button-next');
            this.prev_btn = this.root.parentElement.querySelector('.js-button-prev');
        }

        //do not enable slider functionality if there's only one slide
        if(this.slides.length <= 1) {
            if(this.next_btn) {
                this.next_btn.classList.add('--hidden');
            }

            if(this.prev_btn) {
                this.prev_btn.classList.add('--hidden');
            }

            return;
        }

        if(!options.swiperOptions) {
            options.swiperOptions = {};
        }

        this.swiper = new Swiper(this.container, {
            loop: true,
            autoplay: {
                delay: 5000,
                pauseOnMouseEnter: true,
                disableOnInteraction: false
            },
            navigation: {
                nextEl: this.next_btn,
                prevEl: this.prev_btn,
            },
            ...options.swiperOptions
        });

        if(options.hideArrows && options.hideArrows == true) {
            this.root.addEventListener('mouseenter', (event) => {
                this.next_btn.classList.remove('--hidden');
                this.prev_btn.classList.remove('--hidden');
            });

            this.root.addEventListener('mouseleave', () => {
                this.next_btn.classList.add('--hidden');
                this.prev_btn.classList.add('--hidden');
            });
        }
    }
}
